import { Component, OnInit } from '@angular/core';
import { Context, ContextMenu } from '../../models';
import { ContextService } from './context.service';


@Component({
  selector: 'bidi-side-menu-right',
  templateUrl: './side-menu-right.component.html',
  styleUrls: ['./side-menu-right.component.scss']

})
export class SideMenuRightComponent implements OnInit {

  contexts: Context[];
  menu: ContextMenu[];
  open = false;

  constructor( private contextService: ContextService) { }

  ngOnInit() {
    this.contexts = this.contextService.getContext();
    this.menu = this.contextService.getContextMenu();
  }

  navigateToOption(parameter) {

  }
  openOptions() {
    this.open = true;
  }
  goBack() {
    this.open = false;
  }


}
